// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"112":"build-glob","220":"build-doc","839":"build-map"}[chunkId] + "-legacy." + {"112":"8318ee5a","220":"b19ec894","839":"3daad247"}[chunkId] + ".js";
};